/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CodeAndLabelWithIndent
 */
export interface CodeAndLabelWithIndent {
    /**
     * 
     * @type {number}
     * @memberof CodeAndLabelWithIndent
     */
    indent?: number;
    /**
     * 
     * @type {string}
     * @memberof CodeAndLabelWithIndent
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CodeAndLabelWithIndent
     */
    label?: string | null;
}

export function CodeAndLabelWithIndentFromJSON(json: any): CodeAndLabelWithIndent {
    return CodeAndLabelWithIndentFromJSONTyped(json, false);
}

export function CodeAndLabelWithIndentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodeAndLabelWithIndent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'indent': !exists(json, 'indent') ? undefined : json['indent'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function CodeAndLabelWithIndentToJSON(value?: CodeAndLabelWithIndent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'indent': value.indent,
        'code': value.code,
        'label': value.label,
    };
}


